import { TableauDashboard } from '../TableauDashboard';
import { Document } from '../v2/Document';
import { VolatilityModel } from '../VolatilityModel';
import { StockDropModel } from '@/types/StockDropModel';

export interface Card {
  id: string;
  title: string;
  type: 'tableau' | 'document' | 'volatility' | 'stock_drop' | 'cyber';
  client: string;
  created_by?: string;
  created_on: string;
  updated_on: string;
}

export interface TableauDashboardCard extends Card {
  dashboard: TableauDashboard;
  url: string;
}

export interface DocumentCard extends Card {
  document: Document;
}

export interface VolatilityModelCard extends Card {
  model: VolatilityModel;
}

export interface StockDropModelCard extends Card {
  model: StockDropModel;
}

export interface CyberModelCard extends Card {
  accountId: string;
  published: boolean;
}

export function isTableauDashboardCard(card: Card): card is TableauDashboardCard {
  return 'dashboard' in card;
}

export function isDocumentCard(card: Card): card is DocumentCard {
  return 'document' in card;
}

export function isVolatilityModelCard(card: Card): card is VolatilityModelCard {
  return 'model' in card && card.type === 'volatility';
}

export function isStockDropModelCard(card: Card): card is StockDropModelCard {
  return 'model' in card && card.type === 'stock_drop';
}

export function isCyberModelCard(card: Card): card is CyberModelCard {
  return 'accountId' in card && card.type === 'cyber';
}

export function isPinned(card: Card): boolean {
  if (isTableauDashboardCard(card)) {
    return !!card.dashboard.pinned;
  }
  if (isDocumentCard(card)) {
    return !!card.document.pinned;
  }
  if (isVolatilityModelCard(card) || isStockDropModelCard(card)) {
    return !!card.model.pinned;
  }
  return false;
}

export function isPinnable(card: Card): boolean {
  return !isCyberModelCard(card);
}
